module.exports = __webpack_public_path__ + "static/media/Benvenuti_a_Milano_-_Italiano.7654b3d2.pdf";